export const Services = {"GET_WAREHOUSING":{"path":"https://poseidonapiwarehousing.azurewebsites.net/","method":"GET","descrp":"GET ALL WAREHOUSING"}}